import { password, passwordDisable } from "helper/icons";
import "./styles.css";
import { useState } from "react";

export const TextInput = (props) => {
  const {
    label,
    placeholder,
    type = "text",
    width = "w-[358px] lg:w-[384px] max-[400px]:w-[100%]",
    errorMsg = "",
    name,
    register,
    value,
    className = "",
    disabled = false,
    pattern = "\\S+.*\\S*",
    textTransform = "capitalize",
    adornment,
    ...rest
  } = props || {};
  const isPassword = type === "password";
  const [showPassword, setShowPassword] = useState(false);

  // Password fields should never have text-transform applied to avoid confusion
  const finalTextTransform = isPassword ? "none" : textTransform;

  return (
    <div className="flex flex-col w-[100%]">
      {!!label && (
        <span className="text-gray-700 font-medium text-sm mb-1.5">
          {label}
        </span>
      )}
      <div className={`flex row ${isPassword ? "relative" : ""}`}>
        <input
          {...register?.(name)}
          type={isPassword ? (!showPassword ? "password" : "text") : type}
          placeholder={placeholder}
          className={`${finalTextTransform} ${width} ${className} ${
            disabled && "bg-white"
          } rounded-md border shadow-md ${
            errorMsg ? "border-red" : ""
          } py-2.5 ${adornment ? "pl-[45px] pr-3.5" : "px-3.5"} ${
            disabled ? "text-gray-900/50" : "text-gray-900"
          } font-inter font-normal text-md leading-6 text-base inputFocus focus:outline-none`}
          value={value}
          disabled={disabled}
          // title="cannot consist of only spaces"
          // pattern={pattern}
          {...rest}
          onInput={(e) => {
            if (type !== "number") return;
            e.target.value = e.target.value.replace(/\D/g, "");
          }}
        />
        {isPassword && (
          <img
            src={showPassword ? password : passwordDisable}
            onClick={() => setShowPassword(!showPassword)}
            alt=""
            height={20}
            width={20}
            className="custom-icon"
          />
        )}
        {adornment && (
          <span className="absolute pointer-events-none flex flex-row items-center px-3">
            <div>{adornment}</div>
            <div className="w-[1.2px] bg-gray-300 ml-2.5 h-[46px]" />
          </span>
        )}
      </div>
      {type === "password" && errorMsg === "" && (
        <span className="text-xs text-gray-500 py-1">
          Passwords are case sensitive.
        </span>
      )}
      {!!errorMsg && (
        <span className="text-red font-medium max-w-[352px] text-sm mt-1">
          {errorMsg}
        </span>
      )}
    </div>
  );
};
